<!--
 * @Author: ldx
 * @Date: 2024-01-19 13:46:18
 * @LastEditors: wyj
 * @LastEditTime: 2024-10-30 11:17:51
 * @Description: 云课堂资源平台-用户协议
-->
<template>
  <div style="padding: 10px 14px">
    <h3>云课堂资源平台用户协议</h3>
    <p>
      欢迎使用
      <strong>云课堂资源平台</strong>
      （下称“本平台”或“云课堂资源登录平台”）产品及服务！
    </p>
    <p>
      本协议系由您与
      <strong>云课堂资源平台</strong>
      的软件及服务提供者
      <strong>东莞市晟沃信息科技有限公司</strong>
      （注册地址：
      <strong>广东省东莞市松山湖园区科技十路5号11栋1单元</strong>
      ，以下简称“安道”或“我们”）于
      <strong>东莞市松山湖</strong>
      签署。
    </p>
    <strong>
      <p class="underline">
        请您务必审慎阅读、充分理解本协议各条款内容，特别是免除或者限制“晟沃”责任的条款、对用户权利进行限制的条款、约定争议解决方式和司法管辖的条款等，以及开通或使用某项服务的单独协议。限制、免责条款或者其他涉及您重大权益的条款可能以加粗、加下划线等形式提示您重点注意。
      </p>
    </strong>
    <strong>
      <p>
        当您阅读、并点击确认同意本协议后，即表示您已充分阅读、理解并同意接受本协议的全部内容，并与本平台达成一致，成为本平台的“用户”。因提供本平台相关服务及运营的需要，可能会由我们的关联方或我们认可的第三方公司向您提供本协议项下涉及的某些服务，您知晓并同意接受相关服务内容，即视为接受相关权利义务并受本协议的约束。如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。
      </p>
    </strong>
    <p>如果您对本协议有任何的疑问、投诉、意见和建议，欢迎您通过本协议及本平台中所附联系方式与我们沟通反馈，我们⼗分乐意为您进行解答。</p>
    <strong>
      <p>
        本平台的产品和服务主要面向学校教师及学生家长等成年人，不会开放给未满十八周岁的未成年人（包括儿童），如果您是未成年人，尤其是不满十四周岁的儿童，敬请不要注册成为我们的用户，也不要在未经您的监护人的同意和指导下使用我们的产品及服务。
      </p>
    </strong>

    <strong>
      <p>一、基础约定</p>
    </strong>
    <p>
      （一）协议范围：考虑到互联网服务以及产品频繁迭代更新等行业特点，为了更全面的界定用户与“安道”之间的权利义务，本协议包括我们根据法律法规规定、本协议以及我们制定的
      <span class="primaryColor underline">《云课堂资源平台》</span>
      、以及其他政策、规则、说明、协议、公告声明等（除非特有所指，合称为“本协议”，
      <strong>前述平台规则均被视为本协议不可分割的一部分，与本协议正文具有同等的法律效力）</strong>
      ，用户一旦选择同意，则同样受到约束。当然，您也可以选择不接受可与本平台核心功能单独分割功能的单独规则，这并不影响您使用该功能服务以外的其它功能的使用。
    </p>
    <p>
      （二）协议修改与更新：我们有权遵照法律法规规定，在必要时修改本协议，更新后的协议条款将代替原来的协议并在法律规定的期限届满后正式生效，我们将以推送通知或弹窗等方式通知到您，您可以在相关服务页面查阅最新版本的协议条款。本协议修改后，如果您继续使用云课堂资源平台的，即视为已接受修改后的协议。如果您不接受修改后的协议，则您有权停止使用云课堂资源平台。
    </p>
    <p>（三）服务范围：我们可能通过不断丰富的功能界面向用户提供本协议项下的软件服务。具体以我们实时发布的服务功能界面范围为准。</p>
    <p>
      （四）功能更新：为更好地给您提供相关服务，并保证本平台的安全性，我们将不定期提供本平台及相关服务的更新或改变（包括但不限于软件修改、升级、部分功能停用、功能强化、开发新服务、软件替换等）。我们将在可行情况下以适当方式（包括但不限于系统提示、公告、站内信等）提示您，您有权选择接受更新后版本；如您选择不作更新，则本平台及相关服务的部分功能将受到限制或不能正常使用。
    </p>
    <p>
      （五）兼容和适配：本平台可能需要您有适配兼容的设备终端及操作系统，否则可能影响本平台以及本服务的稳定兼容性。本平台的内容和功能有可能会根据您所使用的终端型号、操作系统的不同而有所不同或变化。
    </p>
    <p>
      （六）目的使用：本平台授予用户一项个人的，不可转让、出借和赠与，非商业化目的使用的，以及免费使用（本协议另有声明及本平台中单独的付费资源除外）的许可。您依本协议条款所取得的权利不可转让。您使用该帐号时涉及的我们服务的所有权、知识产权等合法权利和权益均归我们所有，受著作权法、国际著作权条约以及其他相关法律法规的保护。
    </p>
    <strong>
      <p>二、服务内容和使用规范</p>
    </strong>
    <strong>
      <p>
        （一）云课堂资源平台是晟沃旗下品牌产品，主要面向教师、家长等群体提供用户注册、登录、账号信息管理服务以便使用晟沃旗下产品。请您理解并知悉，我们的服务可能会根据用户的需求或公司运营的需要不时调整更新，请以我们服务界面实时展示的服务功能为准。
      </p>
    </strong>
    <p>
      （二）您在使用本平台服务时需要注册一个安道账号。在您申请注册安道账号前，您应知悉：您应当年满十八周岁，具备中华人民共和国法律规定的与您行为相适应的民事行为能力。
      <strong>若您不具备前述与您行为相适应的民事行为能力，则您只能浏览。</strong>
    </p>
    <p>
      （三）本协议所称的“安道账号”是指您填写信息并申请的合法、有效的账号。您需要按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序。注册账号所需信息包括但不限于您的手机号码、密码、注册或更新安道帐号时输入的所有信息，以及您使用我们一些单项服务时输入的名称、头像等所有信息。请保持这些信息的及时更新，以便我们向您提供帮助，或更好地为您提供服务。
      <strong>
        若国家法律法规有特殊规定的，您需要填写真实的身份信息或提供相关法律规定所要求的特殊信息。若您提供的信息不完整或不准确，则可能无法使用服务或在使用过程中受到限制。
      </strong>
    </p>
    <p>
      （四）注册成功后，我们将给予您一个安道账号，您将获得该账号的使用权，可以对该账号的信息进行管理，并使用该账号登录我们提供的其他服务。该帐号和密码由您负责保管。
      <strong>该账号的所有行为以我们后台记录的操作日志为准，均视为您本人行为，您应当对以其用户帐号进行的所有活动和事件负法律责任。</strong>
    </p>
    <p>
      （五）您承诺以真实身份注册成为本平台用户，并保证所提供的信息真实、完整、有效，依据法律规定和本协议约定对所提供的信息承担相应的法律责任
      <strong>
        ，对于因您提供的信息不真实、不准确或不完整导致的责任和损失由您自行承担。此外，您提交的安道帐号名称、头像和简介等信息中不得出现违法和不良信息，经我们审核，如存在上述情况，我们可能将不予注册；同时，在注册后，如发现您以虚假信息骗取注册，或帐号头像、简介等注册信息存在违法和不良信息的，我们有权不经通知单方采取限期改正、暂停使用、注销、收回账号等措施。
      </strong>
    </p>
    <p>
      （六）安道帐号的效力范围及于我们及授权合作伙伴的产品和服务，您在注册安道帐号后无需重复注册，即可登录和使用所有支持该帐号登录的产品和服务。
      <strong>
        您在享受任何单项产品或服务时，均应当受本协议条款的约束。您在享受任何单项产品或服务时，除了受本协议约束外，您也需另行阅读并接受各单项产品或服务单独提示您的用户协议及隐私政策等单项协议，若该类单项协议与本协议存在冲突的，则在单项协议约束范围内应以单项协议为准。
      </strong>
    </p>
    <p>
      （七）您注册成功后，在后续的登录页面或使用本产品过程中可以更换头像、昵称，或修改密码，或根据您的使用需要完善相关个人资料，以获得更好的用户体验，但是该资料完善程度不会影响您继续持有本账号。
    </p>
    <p>
      （八）您理解并同意，随着我们的服务的不断调整和更新，云课堂资源平台提供的部分网络服务将可能为付费的网络服务，您使用付费网络服务需要向云课堂资源平台（或第三方服务提供商）支付一定的费用。若本平台中可能存在相关付费网络服务，我们会在您使用之前给予您明确的提示，您可以自愿选择是否使用该付费服务。
    </p>
    <p>
      （九）您知悉并理解，我们仅提供本协议项下的服务，除此之外与相关网络服务有关的设备（如各类终端，个人电脑、手机及其他与接入互联网有关的装置）、软件及入网等所需的费用（如为接入互联网而支付各类费用）均应由用户自行负担。
    </p>
    <p>
      （十）您可以在具备安装、运行环境的终端设备（下统称“终端设备”）上安装、使用、显示、运行本平台。您应自行选择与您的终端设备、系统等相匹配的软件版本，否则，可能无法使用本平台及服务。
    </p>
    <strong>
      <p>（十一）您应承诺合法使用本平台，您使用本平台的行为应符合当地的法律法规及政策的要求，否则由此带来的责任由您自行承担。</p>
    </strong>
    <strong>
      <p>三、权利限制</p>
    </strong>
    <strong>
      <p>
        （一）禁止反向工程、反向编译和反向汇编：您不得对本平台产品进行反向工程（Reverse
        Engineer）、反向编译（Decompile）或反向汇编（Disassemble），同时不得改动编译在程序文件内部的任何资源。除法律、法规明文规定允许上述活动外，您必须遵守本协议限制。
      </p>
    </strong>
    <strong>
      <p>（二）禁止组件分割：本平台产品中的每个组件均是本平台不可分割的一部分，您不得基于任何目的将相关组件分开使用。</p>
    </strong>
    <strong>
      <p>（三）商业许可使用：如需进行商业性的销售、复制、分发，包括但不限于软件销售、预装、捆绑等，必须获得晟沃的书面使用和许可。</p>
    </strong>
    <strong>
      <p>（四）保留权利：本协议未明示许可的其他一切权利仍归晟沃所有，您使用其他权利时必须获得晟沃的书面同意。</p>
    </strong>
    <strong>
      <p>四、用户使用须知</p>
    </strong>
    <strong>
      <p>（一）在您使用本平台所提供的服务时，您同意遵守以下账号使用规则：</p>
    </strong>
    <p>1. 您应当理解，在使用本平台时我们可能需要用户提供一些必要的信息，并牢记自己的账号信息，以确保用户对账号享有使用权限。</p>
    <p>
      2. 您应当理解，为了能更好保障您账号自身的安全，我们建议您使用复杂的且不同于您在任何其他服务中使用的密码进行创建和登录，并且当您使用本服务完毕后，应执行安全退出方式。
      <strong>
        因您自身原因未能确保您的账号信息的安全而造成任何损失或损害的，由您自行承担。如果您发现有人未经授权使用您的账号信息或怀疑任何人未经授权可能能够访问您的账号，您应立即更改密码，并通知我们。
      </strong>
    </p>
    <p>
      3.
      <strong>您须保证所填写及所提供的资料真实、准确、完整。</strong>
      我们有权根据用户所提供资料的真实性、准确性、完整性以及是否符合用户与我们之间约定的其他条件，决定是否为用户提供服务。您在使用本平台过程中，如所提供的信息发生变动且此类信息将对本协议及相关约定的履行产生影响的，应及时通知我们。
    </p>
    <strong>
      <p>
        4.安道账号之所有权归晟沃所有，用户在本协议有效期内仅享有使用权。未经我们同意，用户的账号仅供用户本人使用，账号信息和权限不得以转让、赠与、借用、售卖、授权或租用等方式许可给第三方使用或和第三方共同控制、使用，或使用自动执行工具（各类脚本、爬虫等计算机程序）使用。
      </p>
    </strong>
    <strong>
      <p>5. 除晟沃存在过错外，您应对您账号项下的所有行为结果（包括但不限于在线签署各类协议、发布信息、购买我们的产品及服务及披露信息等）负责。</p>
    </strong>
    <p>
      （二）您知悉并同意，在使用本平台相关功能过程当中产生的数据信息，我们均有可能依法进行必要的处理并存储。您对自行发表、上传或传送的内容负全部责任，您使用晟沃相关服务时承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等，
      <strong>您不得在使用本平台过程中发布、转载、传送含有下列内容之一的信息，否则我们有权不经通知自行采取相应处理措施：</strong>
    </p>
    <p>1. 违反宪法确定的基本原则的；</p>
    <p>2. 危害国家安全，泄漏国家机密，颠覆国家政权，破坏国家统一的；</p>
    <p>3. 损害国家荣誉和利益的；</p>
    <p>4. 煽动民族仇恨、民族歧视，破坏民族团结的；</p>
    <p>5. 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
    <p>6. 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
    <p>7. 散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</p>
    <p>8. 侮辱或者诽谤他人，侵害他人合法权益的；</p>
    <p>9. 煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；</p>
    <p>10. 以非法民间组织名义活动的；</p>
    <p>11. 含有法律、行政法规禁止的其他内容的。</p>
    <p>您须对自己在网上的言论和行为承担法律责任，您若在本平台上发布、转载、传达上述信息的，本平台的系统记录有可能作为您违反有关法律、行政法规的证据。</p>
    <p>
      （三）为了改善用户体验、完善服务内容，我们会不断完善相关服务，
      <strong>并为您不时提供软件更新（这些更新可能会采取软件替换、修改、功能强化、版本升级等形式）。</strong>
      本平台新版本发布后，旧版本的软件可能无法使用。我们不保证旧版本平台及相关服务继续可用。
    </p>
    <strong>
      <p>（四）您应在遵守法律法规及本协议的前提下使用本平台，您不得实施以下行为，包括但不限于：</p>
    </strong>
    <p>1. 删除或者改变本平台及其他副本上的所有关于版权的信息、内容或其他类型的权利声明；</p>
    <p>2. 故意避开或者破坏著作权人为保护本平台著作权而采取的技术措施；</p>
    <p>3. 利用本平台误导、欺骗他人；</p>
    <p>4. 违反国家规定，对计算机信息系统功能进行删除、修改、增加、干扰，造成计算机信息系统不能正常运行；</p>
    <p>5.未经允许，进入计算机信息网络或者使用计算机信息网络资源；</p>
    <p>6.未经允许，对计算机信息网络功能进行删除、修改或者增加；</p>
    <p>
      7.
      对于本平台相关信息等，未经我们书面同意，擅自实施包括但不限于下列行为：使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版，建立镜像站点、擅自借助本平台或我们享有合法权利的内容发展与之有关的衍生产品、作品、服务、插件、外挂、兼容、互联等；
    </p>
    <p>8. 破坏本平台系统或网站的正常运行，故意传播计算机病毒等破坏性程序；</p>
    <p>
      9.
      利用本平台发表、传送、传播、储存违反国家法律、危害国家安全、祖国统一、社会稳定、公序良俗的内容，或任何不当的、侮辱诽谤的、淫秽的、暴力的及任何违反国家法律法规政策的内容；
    </p>
    <p>
      10.
      利用本平台传送或散布以其他方式实现传送含有受到知识产权法律保护的图像、相片、软件或其他资料的文件，作为举例（但不限于此）：包括著作权、商标权、肖像权、隐私权等，除非用户拥有或控制着相应的权利或已得到软件知识产权所有人的必要认可；
    </p>
    <p>11. 以任何方式协助他人使用爬虫、蜘蛛等方式爬取本平台上的内容；</p>
    <p>12. 以任何不合法的方式、为任何不合法的目的、或以任何与本协议不一致的方式使用本平台和我们提供的其他服务；</p>
    <p>
      13.
      您若违反上述规定，我们均有权不经通知随时采取删除侵权内容、处罚违规帐号、终止、完全或部分中止、限制用户软件的使用功能等措施。如果您发现任何人违反本协议规定或以不正当方式使用本服务，请立即向我们投诉，我们将依法进行处理。
    </p>
    <strong>
      <p class="underline">（五）您理解并同意，因您违反本协议的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任，我们因此遭受损失的，您应当一并赔偿。</p>
    </strong>
    <strong>
      <p>
        （六）我们强烈建议您不要从非晟沃指定的网址登录本平台，或从非晟沃指定的渠道获得、下载我们及授权合作伙伴提供的其他单项产品和服务，否则我们无法保证相应产品和服务是否感染计算机病毒、是否隐藏有伪装的特洛伊木马程序或者黑客软件，使用此类软件，将可能导致不可预测的风险，该等风险将由您自行承担。
      </p>
    </strong>
    <p>
      （七）您知悉并同意，您使用本平台时，本平台可能会调用我们的其他软件、第三方系统或者通过第三方软件功能支持您的使用或访问。本平台与其他软件之间以及与其他第三方软件之间可能存在互相调用功能、共享数据、打开第三方资源链接等情形；同时，为提高用户体验度，在实现部分软件功能时需要您授权打开终端设备相关辅助设备（比如摄像头等）或者同意调用终端设备本地数据文件，您如拒绝打开辅助设备或者调用本地数据的，则可能导致部分功能无法实现；因您执行上述指令导致相关用户信息被其他第三方恶意利用、窃取甚至删除的，我们会尽力采取必要的措施，以维护您的合法权益不受侵犯。
    </p>
    <strong>
      <p>
        （八）我们可将对您的违约行为的处置信息，以及其他经国家行政或司法机关生效法律文书确认的违法信息，在本平台上予以公示。对涉嫌违反法律法规的行为，我们有义务保存有关记录，向国家有关机关报告并配合调查。
      </p>
    </strong>
    <p>
      （九）您理解，晟沃始终在不断变更和改进服务。晟沃可能会增加或删除本平台的部分或全部功能，也可能暂停或彻底停止某项服务。您同意，晟沃有权行使上述权利且不需对您或第三方承担任何责任。
    </p>
    <p>
      （十）在您需要终止使用本平台服务时，您可以申请注销您的安道帐号。注销成功后，本平台的帐号信息、使用记录等信息将无法恢复或提供，您所有使用安道帐号登录的单项产品和服务的数据也将全部删除或匿名化，注销后，该等产品和服务均不可再继续正常使用，请您在操作之前自行备份安道帐号相关的所有信息和数据。请您知悉并确认以下注销条件：
    </p>
    <p>1.您仅能申请注销您本人的帐号，并依照我们的流程进行注销；</p>
    <p>2.您仍应对您在注销帐号前且使用我们服务期间的行为承担相应责任；</p>
    <p>3.您自愿放弃安道帐号以及相应单项产品和服务有关的资产和虚拟权益（包括但不限于账户余额、虚拟币、积分、优惠券以及其它全部账户权益等）；</p>
    <p>4.您自愿删除安道帐号以及相应产品和服务有关的全部内容（包括但不限于您发布的图片、音视频、课件、留言评论、互动信息等）；</p>
    <p>5.安道账户内无未完成的订单和服务；</p>
    <p>6.安道账户无任何纠纷，包括投诉举报或被投诉举报；</p>
    <p>7.安道账户已经解除与第三方产品的授权登录或绑定关系。</p>
    <strong>
      <p>五、个人信息保护与隐私政策</p>
    </strong>
    <p>
      （一）我们将与您一同致力于您个人信息的保护。在使用本平台及相关服务的过程中，您可能需要提供您的个人信息，以便我们向您提供更好的服务和相应的技术支持。我们将依法保护您的访问、更正、删除、撤回授权同意等个人信息主体权利，并将运用加密技术、匿名化处理等其他与本平台及相关服务相匹配的技术措施及其他安全措施保护您的个人信息。
    </p>
    <p>（二）您应当严格遵守网络安全法、互联网领域相关法规，严格保护个人隐私及数据安全、遵守我们关于隐私保护的政策。</p>
    <strong>
      <p>
        （三）请您注意，勿在使用云课堂资源平台服务过程中透露自己的各类财产帐户、银行卡、信用卡、第三方支付账号及对应密码等重要信息、资料，否则由此带来的任何损失由您自行承担。
      </p>
    </strong>
    <p>（四）您知悉并了解，就下列相关事宜的发生，我们不承担任何法律责任：</p>
    <p>1.我们根据法律规定或相关政府、司法机关的要求提供您的个人信息；</p>
    <p>2.由于您将账号信息和密码等重要信息告知他人或与他人共享帐户，由此导致的任何个人信息的泄漏，或其他非因我们的原因导致的个人信息的泄漏；</p>
    <p>3.任何由于黑客攻击、电脑病毒侵入造成的信息泄漏；</p>
    <p>4.因不可抗力导致的信息泄漏。</p>
    <strong><p>六、知识产权条款</p></strong>
    <p>
      （一）权利声明：本平台由晟沃开发并提供运营管理服务，其一切知识产权，以及本平台内、与本平台相关的所有信息内容，包括但不限于：文字表述及其组合、图标、图饰、图像、图表、色彩、界面设计、版面框架、图片、素材、有关数据、附加程序、印刷材料或电子文档等均为“晟沃”所有或取得相关权利人授权，受著作权法和国际著作权条约以及其他知识产权法律法规的保护。
    </p>
    <p>（二）基于对数据的合法加工而获得的具有竞争性的数据权益，除法律法规另有规定外，晟沃享有独立的使用权益而无须获得用户的同意。</p>
    <strong>
      <p>
        （三）关于信息内容的投诉或举报。若您在使用云课堂资源平台过程中，不慎受到合法权益的侵犯，您有权通知我们采取必要措施进行处置。若您在使用云课堂资源平台过程中，发现存在违法违规或违反本服务相关规则的情况，您也有权向我们发起举报，我们亦会及时采取必要措施（删除、屏蔽、断开链接或限制使用功能等）进行处置。
      </p>
    </strong>
    <p>
      （四）内容维权授权。在法律法规允许的范围内，您同意并授权晟沃就侵犯用户合法权益的行为（包括但不限于私自复制、使用、编辑、盗用等行为）采取任何形式的法律行动，包括但不限于投诉、诉讼等必要的维权措施。
    </p>
    <strong>
      <p>七、违约责任</p>
    </strong>
    <strong>
      <p>
        （一）如果我们发现、收到他人举报或投诉用户违反本协议约定或违反法律法规和国家有关规定的，我们有权对此独立进行判断，采取警示、冻结、终止/中止/限制使用帐号等功能、删除、屏蔽相关内容或断开链接、中止使用许可和/或服务、解除或终止本协议等合理措施，若您的行为给我们造成损失的（包括但不限于直接损失、名誉损失、第三方的罚款、索赔等），我们有权全额向您追偿。由此给您带来的损失（包括但不限于内容资料、数据等清空等），由您自行承担。
      </p>
    </strong>
    <strong>
      <p>我们的上述独立判断以及后续的法律追诉或索赔可以以存储于安道帐号、系统、数据库的数据或者系统判断结果作为依据，有足够证据能够推翻该等数据的除外。</p>
    </strong>
    <strong>
      <p>
        （二）若您的行为给我们造成损失的（包括但不限于直接损失、名誉损失、第三方的罚款、索赔等），我们有权全额向您追偿。如您导致任何第三方损害的，您应当独立承担责任；晟沃因此遭受损失的，您也应当一并赔偿。
      </p>
    </strong>
    <strong>
      <p>
        （三）本协议终止后，除法律有明确规定外，我们无义务向用户或用户指定的第三方披露用户账号中的任何信息。本协议终止后，我们仍享有下列权利：根据法律规定，继续保存您留存于云课堂资源平台的各类信息；对于您过往的违约行为，我们仍可依据本协议向您追究违约责任。
      </p>
    </strong>
    <strong>
      <p>
        （四）您应自行对因使用本服务而产生或存储在本服务中的数据，在本服务之外，采取合理、安全的备份。若晟沃根据本协议对您采取永久封号等措施的，对于您的与本服务相关的全部数据或您存储在本服务中的全部数据、信息等，晟沃有权将该等数据全部予以删除，相应后果您应自行承担。
      </p>
    </strong>
    <strong>
      <p>（五）责任限制</p>
    </strong>
    <strong>
      <p>
        1.
        我们会尽最大努力向您提供服务，确保服务的连贯性和安全性。您理解，我们不能随时或始终预见和防范法律、技术以及其他风险，包括但不限于不可抗力、网络原因、第三方服务瑕疵、第三方网站等原因可能导致的服务中断、不能正常使用本平台及相关服务以及其他的损失和风险。
        <span class="underline">对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，我们并不承担相应的违约责任：</span>
      </p>
    </strong>
    <strong>
      <p class="underline">（1）因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；</p>
    </strong>
    <strong>
      <p class="underline">（2）因电力供应故障、通讯网络故障等公共服务因素或第三人因素（比如因第三方云服务发生中断等功能障碍事故导致我们无法正常提供软件服务的）；</p>
    </strong>
    <strong>
      <p class="underline">（3）在我们已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。</p>
    </strong>
    <strong>
      <p class="underline">
        2.本平台不含有任何旨在破坏您计算机数据和获取您隐私信息的恶意代码。尽管本平台经过详细的测试，但我们无法保证与所有的软硬件系统完全兼容或完全没有错误与漏洞。如果出现前述情况，您可拨打技术支持电话将情况告知我们，以获得技术支持，我们会尽最大努力解决兼容性问题或系统错误、漏洞问题。如果无法解决前述问题，您可以停止使用和/或删除本平台。由此给您造成损失的，除我们存在故意或重大过失外，您同意晟沃不承担赔偿责任。
      </p>
    </strong>
    <strong>
      <p class="underline">
        3.
        在适用法律允许的最大范围内，对因使用或不能使用本平台所产生的损害及风险，包括但不限于直接或间接的个人损害、商业盈利的丧失、贸易中断、商业信息的丢失或任何其它经济损失，除我们对您遭受的损失存在故意或重大过失外，晟沃不承担任何责任。
      </p>
    </strong>
    <strong>
      <p class="underline">
        4.
        您完全理解并同意，本平台的使用涉及互联网及移动通讯等服务，可能会受到各个环节不稳定因素的影响。因此任何因不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机、电信网络、通信线路等其他我们无法预测或控制的原因，造成的软件服务中断、取消或终止的风险，由此给您带来的损失晟沃不承担赔偿责任。
      </p>
    </strong>
    <strong>
      <p class="underline">
        5.
        我们将通过依法建立相关检查监控制度尽可能保障您在本平台上的合法权益及良好体验，但受制于现有技术手段，基于本平台存在海量信息及信息网络环境下信息与实物相分离的特点，且部分信息为其他用户发布，我们无法逐一审查并保证相关信息资讯没有瑕疵或错误，因此对于前述信息资讯的质量、安全以及合法性、真实性、准确性，您应谨慎判断和自主选择。晟沃仅按照相关法律法规的规定承担相应责任，我们不对第三方的诽谤、犯罪或其他非法行为承担责任，也不赔偿因此造成的您的损失，但因我们对您遭受的损失存在故意或重大过失的除外。
      </p>
    </strong>
    <strong>
      <p class="underline">6. 本协议中包含的所有责任限制和免责事由条款仅适用于法律法规允许的最大限度内。</p>
    </strong>
    <strong>
      <p>八、法律适用与管辖</p>
    </strong>
    <p>
      本协议的订立、执行、解释及争议的解决均适用中华人民共和国法律。如双方就本协议内容或其履行发生任何争议，双方应尽力友好协商解决；
      <strong class="underline">协商不成时，任何一方均可向本协议签订地提起诉讼。</strong>
    </p>
    <strong>
      <p>九、其他条款</p>
    </strong>
    <p>（一）如果本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，或违反任何适用的法律，则该条款被视为删除，但本协议的其余条款仍有效并且具有约束力。</p>
    <p>
      （二）如果本协议中的任何条款与我们或授权合作伙伴提供的某单项产品或服务的协议条款相矛盾的，以该单项产品或服务的协议条款为准。对于可能出现的纠纷，我们与该项产品或服务的提供方在法律法规和协议约定的范围内各自承担责任。
    </p>
    <strong>
      <p>
        （三）再次提示，我们有权随时根据有关法律、法规的变化以及公司经营状况和经营策略的调整等修改本协议。修改后的协议会在本平台上公布。当发生有关争议时，以最新的协议文本为准。如果不同意改动的内容，您可以联系我们，或自行停止使用本平台。如果您继续使用本平台，则视为您接受本协议的变动。当您注销您的用户账号或我们通知您终止为您提供本平台及其服务（包括但不限于封禁账号、注销账号等）时，本协议将同时终止，晟沃将不再另行通知您终止本协议。
      </p>
    </strong>
    <strong>
      <p>
        （四）在晟沃发生合并、分立、收购、资产转让时，我们可向第三方转让本服务下相关资产；也可在单方通知您后，将本协议下部分或全部服务转交给第三方运营或履行。具体受让主体以我们通知的为准。
      </p>
    </strong>
    <p>
      （五）在注册安道帐号时，您应该向我们提供真实有效的联系方式（包括您的手机号码等），对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被联系的状态。
      <strong>我们将向您的联系方式向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。</strong>
    </p>
    <strong>
      <p class="underline">
        至此，您已经详细阅读并已理解本协议，并同意严格遵守各项条款和条件。如果您对本协议有任何疑问或者希望获得与本平台相关的任何信息，请按下列联系方式与我们联系。
      </p>
    </strong>
    <p>运营方：东莞市晟沃信息科技有限公司</p>
    <p>地址：广东省东莞市松山湖园区科技十路5号11栋1单元</p>
    <p>联系电话：400-632-8880</p>
  </div>
</template>
<script>
import utils from '@/utils/index'
import config from '@/config/index'
export default {
  data() {
    return {
      activationCompany: {
        company: '东莞市安道光电材料制造有限公司',
        address: '广东省东莞市松山湖国际金融园C区11栋A座',
        abbreviation: '安道'
      }
    }
  },
  created() {
    this.activationCompany = config.companyList[0]
  },
  mounted() {
    const identify = utils.getParamByUrl('cType')
    if (identify) {
      this.activationCompany = config.companyList[identify]
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
h3 {
  font-size: 16px;
  text-align: center;
}

p {
  font-size: 14px;
  text-indent: 2em;
}
.underline {
  text-decoration: underline;
}
.primaryColor {
  color: #1e80ff;
}
</style>
